<template>
  <div>
    <v-container>
      <p :class="[$style.headingText]">
        {{ lang.publication_type + lang.required }}
      </p>
      <v-radio-group
        :value="publicationType"
        @change="updatePublicationType"
        row
      >
        <v-radio :label="lang.publication_type_public" value="public"></v-radio>
        <v-radio
          :label="lang.publication_type_secret_word"
          value="secret_word"
        ></v-radio>
      </v-radio-group>

      <v-fade-transition leave-absolute>
        <v-text-field
          v-if="publicationType == 'secret_word'"
          :label="lang.secret_word"
          :value="secretWord"
          @input="updateSecretWord"
          type="password"
          :counter="50"
          background-color="amber lighten-4"
          solo
        ></v-text-field>
      </v-fade-transition>

      <v-responsive max-width="100%">
        <v-checkbox
          :value="isSensitive"
          :label="lang.is_sensitive"
          @change="updateIsSensitive"
          :true-value="true"
          :false-value="false"
          :hint="
            '<div class=\'pl-4 body-2\' style=\'line-height: 1.5em\'>' +
              sensitiveHint +
              '</div>'
          "
          persistent-hint
          class="mb-2 d-block"
        ></v-checkbox>
      </v-responsive>
      <v-card
        class="text-xs-center body-2 orange darken-2 pa-1 white--text"
        flat
        max-width="60"
      >
        {{ lang.hint_card_text }}
      </v-card>
      <v-responsive max-width="100%">
        <ul class="ml-4 pb-4 pt-1 body-2">
          <li v-html="sensitiveHintText"></li>
        </ul>
      </v-responsive>

      <p :class="[$style.headingText]">{{ lang.is_comment_enabled }}</p>
      <v-radio-group
        :value="isCommentEnabled"
        @change="updateIsCommentEnabled"
        row
      >
        <v-radio
          :label="lang.is_comment_enabled_accept"
          :value="true"
        ></v-radio>
        <v-radio
          :label="lang.is_comment_enabled_not_accept"
          :value="false"
        ></v-radio>
      </v-radio-group>

      <p :class="[$style.headingText]">{{ lang.circle_ms_client_name }}</p>
      <v-radio-group
        :value="isEnabledCircleMs"
        :disabled="!isClientEnabledCircleMs"
        @change="updateIsEnabledCircleMs"
        row
      >
        <v-radio :label="lang.circle_ms_enabled" :value="true"></v-radio>
        <v-radio :label="lang.circle_ms_disabled" :value="false"></v-radio>
      </v-radio-group>
      <div class="mb-2 pl-4">
        <vc-share-text-contains-link
          :replace="{
            ':name': {
              text: lang.circle_ms_description_name,
              href: circleMsUrl,
              target: '_blank'
            },
            ':help_link': {
              text: lang.circle_ms_description_help_link,
              href: circleMsMyPortalUrl,
              target: '_blank'
            }
          }"
        >
          <div>
            {{ lang.circle_ms_description }}
            <span v-if="locale !== 'ja-jp'">{{ lang.japanese_only }}</span>
          </div>
          <div v-if="!isClientEnabledCircleMs">
            {{ lang.circle_ms_description_help }}
          </div>
        </vc-share-text-contains-link>
      </div>
      <v-card
        class="text-xs-center body-2 orange darken-2 pa-1 white--text"
        flat
        max-width="60"
      >
        {{ lang.hint_card_text }}
      </v-card>
      <v-responsive max-width="100%">
        <ul class="ml-4 pb-4 pt-1 body-2">
          <li>{{ lang.circle_ms_description_hint_1 }}</li>
          <li>{{ lang.circle_ms_description_hint_2 }}</li>
        </ul>
      </v-responsive>
    </v-container>
  </div>
</template>

<script>
import ice from "../../../lib/ice";

export default {
  name: "vc-share-comic-meta-form",
  props: {
    lang: {
      type: Object,
      default: () => ({
        publication_type: "公開範囲を設定する",
        publication_type_public: "誰でも閲覧可能",
        publication_type_secret_word: "合言葉が必要",
        secret_word: "合言葉",
        is_comment_enabled: "コメント投稿",
        is_comment_enabled_accept: "受け付ける",
        is_comment_enabled_not_accept: "受け付けない",
        is_sensitive: "自主規制を設定する",
        is_sensitive_note:
          "例）性的、残酷、グロテスク表現など（ :a_start レーティング基準表 :a_end を参考に18歳未満の青少年に見せてよいかどうかを基準に判断してください）",
        sensitive_hint_text:
          "設定すると、公開時に :a_start サムネイル・作品情報など :a_end が非表示になります。"
      })
    },
    ratingCriteriaTableUrl: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: ""
    },
    isClientEnabledCircleMs: {
      type: Boolean,
      default: false
    },
    circleMsUrl: {
      type: String,
      default: ""
    },
    circleMsMyPortalUrl: {
      type: String,
      default: ""
    },

    // state
    publicationType: {
      type: String,
      default: ""
    },
    secretWord: {
      type: String,
      default: ""
    },
    isSensitive: {
      type: Boolean,
      default: false
    },
    isCommentEnabled: {
      type: Boolean,
      default: null
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    isEnabledCircleMs: {
      type: Boolean,
      default: false
    },

    //mutations
    updatePublicationType: {
      type: Function,
      default: () => {}
    },
    updateSecretWord: {
      type: Function,
      default: () => {}
    },
    updateIsCommentEnabled: {
      type: Function,
      default: () => {}
    },
    updateIsSensitive: {
      type: Function,
      default: () => {}
    },
    updateIsEnabledCircleMs: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    sensitiveHint: "",
    sensitiveHintText: "",
    sensitiveHintDom: "",
    sensitiveHintTextDom: ""
  }),
  created: function() {
    this.sensitiveHint = this.lang.is_sensitive_note
      .replace(
        ":a_start",
        '<a href="' +
          this.ratingCriteriaTableUrl +
          '" id="upLoadSensitiveHintDom" target="_blank">'
      )
      .replace(":a_end", "</a>");
    this.sensitiveHintText = this.lang.sensitive_hint_text
      .replace(
        ":a_start",
        '<a href="/' +
          this.locale +
          '/help#about-sensitive-contents" id="upLoadSensitiveHintTextDom" target="_blank">'
      )
      .replace(":a_end", "</a>");
  },
  mounted: function() {
    this.sensitiveHintDom = document.getElementById("upLoadSensitiveHintDom");
    this.sensitiveHintDom.addEventListener("click", this.onClick, false);
    this.sensitiveHintTextDom = document.getElementById(
      "upLoadSensitiveHintTextDom"
    );
    this.sensitiveHintTextDom.addEventListener("click", this.onClick, false);
  },
  methods: {
    onClick(event) {
      ice.onClickLink(event);
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
}

.headingText {
  font-weight: bold;
  font-size: 16px;
}
</style>
